export default "__VITE_ASSET__Bjc5amgH__"